// routes
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import Router from './routes';
// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
// components
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';
import GlobalErrorDialog from './components/GlobalErrorDialog';
import GlobalSuccessDialog from './components/GlobalSuccessDialog';
import CustomLoader from './components/CustomLoader';
import useErrorSelector from './store/Slice/Error/ErrorSelector';
import { resetErrorSlice } from './store/Actions';
import 'react-toastify/dist/ReactToastify.css';

// ----------------------------------------------------------------------

export default function App() {
  const dispatch = useDispatch();
  const { ErrorStatus, SuccessStatus } = useErrorSelector();
  const handleCloseMessage = useCallback(() => dispatch(resetErrorSlice()), [dispatch]);

  return (
    <ThemeConfig>
      <ScrollToTop />
      <GlobalStyles />
      <BaseOptionChartStyle />
      <Router />
      <GlobalErrorDialog
        open={Boolean(ErrorStatus?.open)}
        message={ErrorStatus?.message}
        onClose={handleCloseMessage}
      />
      <GlobalSuccessDialog
        open={Boolean(SuccessStatus?.open)}
        title={SuccessStatus?.title}
        message={SuccessStatus?.message}
        onClose={handleCloseMessage}
      />
      <CustomLoader /> {/* Custom Loader */}
      <ToastContainer />
    </ThemeConfig>
  );
}
